import React, { useEffect, useState } from "react";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import { getSupplierInfoAPi } from "../../Api/BarestSupplierServices";
import { errorToast } from "../../Utils/Toast/Toast";
import Style from "./QrCode.module.css";
import { useHistory } from "react-router-dom";
const QrCode = () => {
    const history=useHistory()
  const [infoState, setInfoState] = useState();
  useEffect(() => {
    getSupplierInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //////////// get supplier info /////////////
  const getSupplierInfo = async () => {
    getSupplierInfoAPi((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setInfoState(res.info);
        } else {
          errorToast(res.message);
        }
      } else {
        console.error(res);
      }
    });
  };
  return (
    <div className={Style.pageHolder}>
      <MenuTitle title={"QrCode"} />
      <img src="/Assets/Images/Menu/qr-code.svg" alt="qrcode" />
      <ul className={Style.ListHolder}>
        <li onClick={()=>history.push(`/qrcode-wallet/${infoState?.id}`)}>ایجاد QrCode بدون فاکتور</li>
        <li onClick={()=>history.push(`/qrcode-facture/${infoState?.id}`)}>ایجاد QrCode با فاکتور</li>
        <li onClick={()=>history.push(`/facturelist`)}>بررسی فاکتور و Qrcode های ایجاد شده</li>
      </ul>
    </div>
  );
};

export default QrCode;
